import { Form } from "antd"
import { Button } from "components"
import { AppSegmentWrapper } from "components/custom/AppSegmentWrapper"
import DashboardWrapper from "components/new-stuff/ui/DashboardWrapper"
import { useState } from "react"
import { PermissionsPicker } from "./PermissionsPicker"
import { RoleForm } from "./RoleForm"
import { useNavigate } from "react-router-dom"
import { ICustomRoleRequest, IGetAdminsRes } from "./interface/interface"
import { useMutation, useQuery } from "@tanstack/react-query"
import { useAppNotificationStore } from "stores"
import { LoadingButton } from "components/buttons/LoadingButton"
import SegmentWrapper from "components/custom/SegmentWrapper"
import { onQueryError } from "utils/utils"
import { roleService } from "services/roleService"
import { COMPANY_ENDPOINTS, companyService } from "services/companyService"

const CreateRolePage = () => {
  const [form] = Form.useForm()

  const { toast } = useAppNotificationStore()

  const [employees, setEmployees] = useState<string[]>([])

  const [formData, setFormData] = useState<ICustomRoleRequest>()

  //@: Local state to manage the selected permissions
  const [selectedPermissions, setSelectedPermissions] = useState<string[]>([])

  const { data: admins, isLoading: isGetting } = useQuery<IGetAdminsRes>({
    queryKey: [COMPANY_ENDPOINTS.GET_ADMINS, true],
    queryFn: async () => companyService.getAdmins(true),
    refetchOnWindowFocus: false,
    cacheTime: 24 * 60 * 60 * 1000,
  })

  const navigate = useNavigate()

  const { mutate, isLoading } = useMutation({
    mutationFn: async (data: ICustomRoleRequest) => roleService.create(data),
    onSuccess: (data) => {
      if (data.success) {
        data.message && toast.success(data.message)

        navigate(-1)
      }
    },
    onError: onQueryError,
  })

  return (
    <DashboardWrapper>
      <SegmentWrapper title="Create Custom Role 123">
        <div className="px-4 md:px-6 xl:px-[60px] flex flex-col relative h-screen overflow-y-hidden overflow-x-hidden -mb-10">
          <div className="grid lg:grid-cols-[40%,60%]  grid-cols-1 h-[100%]">
            <RoleForm
              form={form}
              employees={employees}
              setEmployees={setEmployees}
              isEditMode
              showButton={false}
              isCustomRole
              admins={admins?.data || []}
              createMode={true}
              onUpdateData={(values) => {
                setFormData(values as any)
              }}
              onFinish={() => {
                mutate({
                  ...formData,
                  permissions: selectedPermissions.map((permission) =>
                    String(permission)
                  ),
                  assignments: employees?.map((x: string) =>
                    admins?.data?.find((it) => it?.text === x)?.id?.toString()
                  ),
                } as ICustomRoleRequest)
              }}
              showRolePeopleList={false}
            />
            <PermissionsPicker
              isEditMode
              selectedPermissions={selectedPermissions}
              setSelectedPermissions={setSelectedPermissions}
            />
          </div>
          <div className="flex justify-end gap-3 mt-6 border-t pr-3 py-4 absolute bottom-0 right-0 w-full bg-white">
            <Button
              color="neutral"
              onClick={() => navigate(-1)}
              type="button"
            >
              Cancel
            </Button>

            <Button
              color="primary"
              onClick={(e) => {
                e.preventDefault()
                form.submit()
              }}
              type="submit"
              submitting={isLoading}
            >
              Save
            </Button>
          </div>
        </div>
      </SegmentWrapper>
    </DashboardWrapper>
  )
}

export default CreateRolePage
